import { useSelector } from 'react-redux';

import type { DetailMdScore } from '@/domains/productDiscovery/ArticleReviews/ArticleReviews.model';
import { mdScoresSelector } from '@/domains/productDiscovery/ArticleReviews/MdScores.ducks';

export const useMdsWithRanking = () =>
  useSelector(mdScoresSelector).data.filter(
    (md: DetailMdScore) => md.ranking?.length >= 5,
  );
